import React, { useState } from 'react';
import { TestCycleToolbar } from '../../ui/primitives/ActionToolbar';
import CloneTestCycleModal from '../../components/project-dashboard/test-cycles/CloneTestCycleModal';
import { deleteTestCycle } from '../../modules/testcycles';
import { deletionIssues } from '../../components/project-dashboard/test-cycles/static-data';
import ConfirmationModal from '../../ui/primitives/ConfirmationModel';
import { Stack, Typography } from '@mui/material';

const TestCycleTableActions = ({
  handleOpenTestCycleModal,
  selectedItems = [],
  isSelectedItems,
  selectedRows = [],
  addNotification,
  refreshData,
}) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showCloneModal, setShowCloneModal] = useState(false);

  const handleDelete = async () => {
    try {
      await deleteTestCycle({ testcycles: selectedItems });
      refreshData();
      addNotification('success', 'Test cycle(s) deleted successfully!');
      setShowDeleteModal(false);
    } catch (error) {
      addNotification('danger', error?.message ?? 'Failed to delete test cycle. Please try again later.');
    }
  };

  return (
    <>
      <TestCycleToolbar
        onAdd={handleOpenTestCycleModal}
        onClone={() => setShowCloneModal(true)}
        onDelete={() => setShowDeleteModal(true)}
        isSelectedItems={isSelectedItems}
      />

      <ConfirmationModal
        show={showDeleteModal}
        handleClose={() => setShowDeleteModal(false)}
        handleConfirm={handleDelete}
        title="Remove Test Cycle"
        body={
          <Stack direction="column" spacing={1}>
            <Typography>Removing the test cycle(s) will permanently remove the following:</Typography>
            <Typography component="ul">
              {deletionIssues.map((issue, index) => (
                <li key={index}>{issue}</li>
              ))}
            </Typography>
            <Typography>This action cannot be undone.</Typography>{' '}
            <strong>Are you sure you want to delete the test cycle(s)?</strong>
          </Stack>
        }
        buttonLabel="Delete"
      />

      <CloneTestCycleModal
        show={showCloneModal}
        handleClose={() => setShowCloneModal(false)}
        entityToClone={selectedRows[0]}
        fetchTestCycles={refreshData}
      />
    </>
  );
};

export default TestCycleTableActions;